export enum EFormStatus {
  FORM = 'form',
  SUCCESS = 'success',
  COMMUNICATION_METHOD = 'communicationMethod',
  FAIL = 'fail',
}
export const DEFAULT_VALUE = {
  price: '',
  regions: null,
  minPriceMFO: 0.1,
  minPrice: 1000000,
  maxPriceMFO: 200000000,
  maxPrice: 100000000000000,
}
